var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/socket.io-parser/node_modules/isarray/index.js
// module id = 219
// module chunks = 0